import React from "react";

const characterCountInputMax = (props) => {
  const { maxLength, limitText, baseClass } = props;
  return (count) => (
    <div
      title={limitText || null}
      className={`${baseClass} ${count > parseInt(maxLength, 10) ? "si-count_error" : ""}`}
    >
      {count}/{maxLength}
    </div>
  );
};

export default characterCountInputMax;
